import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { sendBroadcastApi } from '../services/adminBroadcast'

export const sendBroadcast = createAsyncThunk(
  'adminBroadcast/sendBroadcast',
  async ({ subject, body, important, notification_summary, recipients, userId }, thunkAPI) => {
    try {
      return await sendBroadcastApi({ subject, body, important, notification_summary, recipients, userId })
    } catch (err) {
      return thunkAPI.rejectWithValue(err.type || err.message || 'Error desconocido')
    }
  }
)

const adminBroadcastSlice = createSlice({
  name: 'adminBroadcast',
  initialState: {
    loading: false,
    error: null,
    success: false,
    broadcastId: null
  },
  reducers: {
    resetBroadcast: (state) => {
      state.loading = false
      state.error = null
      state.success = false
      state.broadcastId = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendBroadcast.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = false
      })
      .addCase(sendBroadcast.fulfilled, (state, action) => {
        state.loading = false
        state.success = true
        state.broadcastId = action.payload.broadcast_id
      })
      .addCase(sendBroadcast.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Error al enviar el broadcast'
      })
  }
})

export const { resetBroadcast } = adminBroadcastSlice.actions

export const selectBroadcastLoading = (state) => state.adminBroadcast.loading
export const selectBroadcastError = (state) => state.adminBroadcast.error
export const selectBroadcastSuccess = (state) => state.adminBroadcast.success
export const selectBroadcastId = (state) => state.adminBroadcast.broadcastId

export default adminBroadcastSlice.reducer
